<template>
    <div>
        <div class="search-box">
            Find substitutes for missing ingredients in your kitchen
            <auto-complete :data="suggestions" :placeholderText="placeholderText" @input="searchSubtitutes"></auto-complete>
        </div>
        <div class="error error-not-found" v-if="showNotFound">Sorry, no results found for: {{ notFoundItem}}</div>
        <div class="most-popular-items-wrapper" v-if="searchResult.length == 0">
            <h3>Most popular items</h3>
            <div class="list">
                <div class="item-card" v-for="(item, index) in popularIngredients" :key="index">
                    
                    <div class="card-header">
                        <div class="item-name">{{item.ingredient}}</div>
                        <div class="item-amount"><img src=".././assets/icons/ruller.svg" alt="amount"> Amount: {{item.amount}}</div>
                        <div class="item-subtitutes-count"><img src=".././assets/icons/layers.svg" alt="amount"> Subtitutes: {{item.substitutes.length}}</div>
                    </div>
                    
                    <ul>
                        <li v-for="(sub, index) in item.substitutes" :key="index">
                            <p>Subtitute {{index+1}}</p>
                            {{sub.sub}}
                        </li> 
                    </ul>
                </div>
            </div>
        </div>
        <div class="result-wrapper" v-if="searchResult.length">
            <div class="item-card" v-for="(item, index) in searchResult" :key="index">
                    <div class="card-header">
                        <div class="item-name">{{item.ingredient}}</div>
                        <div class="item-amount"><img src=".././assets/icons/ruller.svg" alt="amount"> Amount: {{item.amount}}</div>
                        <div class="item-subtitutes-count"><img src=".././assets/icons/layers.svg" alt="amount"> Subtitutes: {{item.substitutes.length}}</div>
                    </div>
                    <ul>
                        <li v-for="(sub, index) in item.substitutes" :key="index">
                            <p>Subtitute {{index+1}}</p>
                            {{sub.sub}}
                        </li> 
                    </ul>
            </div>
        </div>
    </div>
</template>

<script>
import substitutes from '../assets/data/substitutes.json'
import autoComplete from './autoComplete.vue'
export default {
    name: 'List',
    components: {
        autoComplete
    },
    props: {
        msg: String,
    },
    data() {
        return {
            substitutes: substitutes.items,
            searchResult: [],
            placeholderText: 'Search ingredient...',
            showNotFound: false,
            notFoundItem: '',
        }
    }, 
    computed: {
        suggestions() {
            return this.substitutes.map(item => item.ingredient);
        },
        popularIngredients() {
            return this.substitutes.filter(function(item) {
                return item.popularity === 1;
            });
        }
    },
    methods: {
        searchSubtitutes(value) {
            // reset not found result
            this.showNotFound = false;

            let searchText = value;
            if(searchText === '') {
                this.searchResult = [];
                return;
            }
            
            this.searchResult = this.substitutes.filter(function(item) {
                return item.ingredient === searchText;
            });


            if (this.searchResult.length === 0) {
                this.showNotFound = true;
                this.notFoundItem = searchText;
                console.log('not found', this.notFoundItem);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
